module.exports = __webpack_public_path__ + "img/JP.d733668c.jpg";